<template>
    <div class="page-events">
        <el-card shadow="never" class="m-b-20">
            <el-row :gutter="20">
                <el-col :sm="24" :md="10" :lg="12" :xl="12" class="m-b-10 m-b-md-0">
                    <el-input class="w-100 m-r-20" placeholder="Поиск по событию"
                              v-model="form.SearchString"
                              v-on:change="getData"
                              clearable>
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                </el-col>
                <el-col :sm="24" :md="4" :lg="4" :xl="4" class="m-b-10 m-b-md-0 p-t-10">
                    <el-switch @change="changeNewEvents" v-model="form.showNewEvents" active-text="Автопрокрутка" class="m-r-20 m-b-5"></el-switch>
                </el-col>
                <el-col :sm="24" :md="4" :lg="4" :xl="4" class="m-b-10 m-b-md-0 p-t-10 d-flex align-items-center">
                    <el-switch @change="changeView" v-model="form.viewTable" inactive-text="Плитка" active-text="Таблица"></el-switch>
                </el-col>
                <el-col :sm="24" :md="6" :lg="4" :xl="4" align="right">
                    <el-button class="w-100" type="primary" @click="handleFilter" icon="icon-search">Поиск</el-button>
                </el-col>
            </el-row>
        </el-card>

        <el-card shadow="never" class="events m-b-20">
            <div slot="header">
                <div class="float-right m-b-20 m-b-md-0">
                    <small class="font-weight-bold m-r-10">Выберите фильтр:</small>
                    <el-select v-if="filters" @change="handleChangeFilter" v-model="filterActive" :default-first-option="true" placeholder="Выберите фильтр" class="select-filter">
                        <el-option
                                v-for="(row, index) in filters"
                                :key="index"
                                :label="row.Name"
                                :value="index">
                        </el-option>
                    </el-select>
                </div>

                <h2>Текущие события</h2>

                <div v-loading="loadingFilters" v-if="filters">
                    <!-- eslint-disable-next-line -->
                    <div v-if="filterActive === index" v-for="(filterSet, index) in filters" :key="index" class="filters">
                        <!-- eslint-disable-next-line -->
                        <div v-for="filter in filterSet.DataMemberDescriptions" v-if="filterSet.DataMemberDescriptions" :key="filter.DataMember">
                            <el-select filterable v-if="filter.StandardValues" @change="handleChange" v-model="formDynamic[filter.DataMember]" :placeholder="filter.DisplayName" class="w-100" :clearable="true">
                                <el-option
                                        v-for="(row, index) in filter.StandardValues"
                                        :key="index"
                                        :label="row"
                                        :value="row">
                                </el-option>
                            </el-select>
                            <el-input v-else @change="handleChange" v-model="formDynamic[filter.DataMember]" :placeholder="filter.DisplayName" class="w-100" :clearable="true"></el-input>
                        </div>
                    </div>
                </div>

                <div v-if="form.showNewEvents === false">
                    <div v-if="dataTable.LastEvents && dataTable.LastEvents[0] && dataTableTemp.LastEvents && dataTableTemp.LastEvents[0]">
                        <el-button v-if="dataTable.LastEvents[0].Time !== dataTableTemp.LastEvents[0].Time"
                                   class="m-t-20"
                                   type="primary"
                                   icon="el-icon-refresh"
                                   @click="showNewEvents()"
                        >
                            Есть новые события!
                        </el-button>
                    </div>
                </div>
            </div>

            <div slot="header" v-loading="loadingFilters" class="clearfix events__filters" v-if="filters && filters.DataMemberDescriptions">
                <div v-for="filter in filters.DataMemberDescriptions" class="m-r-10" :key="filter.DataMember">
                    <el-select filterable v-if="filter.StandardValues" @change="handleChange" v-model="formDynamic[filter.DataMember]" :placeholder="filter.DisplayName" class="w-100" :clearable="true">
                        <el-option
                                v-for="(row, index) in filter.StandardValues"
                                :key="index"
                                :label="row"
                                :value="row">
                        </el-option>
                    </el-select>
                    <el-input v-else @change="handleChange" v-model="formDynamic[filter.DataMember]" :placeholder="filter.DisplayName" class="w-100" :clearable="true"></el-input>
                </div>

                <!--
                <div>
                    <label>По типу события</label>
                    <el-select @change="changeMode" clearable v-model="form.Type" placeholder="Тип" class="w-100">
                        <el-option
                                v-for="item in types"
                                :key="item.id"
                                :label="item.value"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div>
                    <label>По уровню события</label>
                    <el-select @change="changeMode" clearable v-model="form.Level" placeholder="Уровень" class="w-100">
                        <el-option
                                v-for="item in levels"
                                :key="item.id"
                                :label="item.value"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div>
                    <label>По квитированию</label>
                    <el-select @change="changeMode" clearable v-model="form.Confirm" placeholder="Квитирование" class="w-100">
                        <el-option
                                v-for="item in confirms"
                                :key="item.id"
                                :label="item.value"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </div>

                <div class="m-r-30">
                    <el-switch @change="changeNewEvents" v-model="form.showNewEvents" active-text="Автопрокрутка" class="m-r-20 m-b-5"></el-switch>
                    <el-switch @change="changeView" v-model="form.viewTable" active-text="Таблица"></el-switch>
                </div>
                -->
            </div>
            <el-row :gutter="20">
                <el-col :span="24">
                    <!--<audio src="~assets/sounds/notification.mp3" controls autoplay></audio>-->

                    <div v-if="form.viewTable === false" class="cards m-20">
                        <el-card :class="row.ColorScheme" v-for="(row, index) in dataTableFiltered" :key="index">
                            <div slot="header" class="clearfix">

                                        <h2 class="m-t-5">
                                            {{row.Time | time}}
                                            <small>
                                                {{row.Time | dateshort}}
                                            </small>

                                            <!--
                                            <el-popover
                                                    title="Подробно"
                                                    trigger="hover"
                                            >
                                                <div>
                                                    <div v-for="(row, index) in row.Cells" :key="index">
                                                        <template
                                                                v-if="dataTable.Headers.find(x => x.DataMember === row.DataMember) &&
                                                                dataTable.Headers.find(x => x.DataMember === row.DataMember).ColumnVisible &&
                                                                row.Value &&
                                                                row.Value !== '0' &&
                                                                row.DataMember !== 'DeviceId' &&
                                                                row.DataMember !== 'Time' &&
                                                                row.DataMember !== 'Type' &&
                                                                row.DataMember !== 'ConfirmationTime' &&
                                                                row.DataMember !== 'ConfirmationOperatorId'"
                                                        >
                                                            <b>{{dataTable.Headers.find(x => x.DataMember === row.DataMember).DisplayName}}:</b>
                                                            <span v-if="dataTable.Headers.find(x => x.DataMember === row.DataMember).DataType === 'DateTime'">
                                                                {{row.Value | date}}
                                                            </span>
                                                            <div v-else-if="dataTable.Headers.find(x => x.DataMember === row.DataMember).DataType === 'Decimal'">
                                                                {{row.Value | rubles }}
                                                            </div>
                                                            <div v-else>
                                                                {{row.Value}}
                                                            </div>
                                                        </template>
                                                    </div>
                                                </div>
                                                <i style="float: right; cursor: pointer;" slot="reference" class="el-icon-info color-dark"></i>
                                            </el-popover>
                                            -->
                                        </h2>

                                <div class="m-t-10"><b>{{(row.DeviceId ? row.DeviceId + ':' : '')}}</b> {{ row.SpecificType ? row.SpecificType : row.Type }}</div>

                                <params v-if="row.Parameters" class="m-t-10 m-b-0" :data="row.Parameters"></params>

                                <div v-for="(row, index) in row" :key="index">
                                    <template
                                            v-if="dataTable.Headers.find(x => x.DataMember === row.DataMember) &&
                                                                dataTable.Headers.find(x => x.DataMember === row.DataMember).ColumnVisible &&
                                                                row.Value &&
                                                                row.Value !== '0' &&
                                                                row.DataMember !== 'DeviceId' &&
                                                                row.DataMember !== 'Time' &&
                                                                row.DataMember !== 'Type' &&
                                                                row.DataMember !== 'ConfirmationTime' &&
                                                                row.DataMember !== 'ConfirmationOperatorId'"
                                    >
                                        <b>{{dataTable.Headers.find(x => x.DataMember === row.DataMember).DisplayName}}:</b>
                                        <span v-if="dataTable.Headers.find(x => x.DataMember === row.DataMember).DataType === 'DateTime'">
                                                                {{row.Value | date}}
                                                            </span>
                                        <div v-else-if="dataTable.Headers.find(x => x.DataMember === row.DataMember).DataType === 'Decimal'">
                                            {{row.Value | rubles }}
                                        </div>
                                        <params v-else-if="row.DataMember === 'Parameters'" class="m-t-10 m-b-0" :data="row.Value"></params>
                                        <div v-else>
                                            {{row.Value}}
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <el-button v-if="row.ConfirmationRequired && row.ConfirmationOperatorId === ''" class="w-100" @click="confirmEvent(row.Id)">Квитировать</el-button>
                            <h3 class="m-t-10 m-l-20" v-if="row.ConfirmationOperatorId !== ''">
                                <small>
                                    <b>{{row.ConfirmationOperatorId}}</b>
                                    {{row.ConfirmationTime | dateshort}} {{row.ConfirmationTime | time}}
                                </small>
                            </h3>
                        </el-card>
                    </div>
                    <div v-else>
                        <el-table
                                v-loading="loading"
                                :data="dataTableFiltered"
                                v-if="dataTable"
                                :row-class-name="tableRowClassName"
                                :row-style="tableRowStyle"
                                :cell-class-name="tableRowClassName"
                                :cell-style="tableRowStyle"
                                :highlight-current-row="false"
                                @selection-change="handleSelectionChange"
                        >
                            <!--v-if="columnVisibility(header, $index)"-->
                            <el-table-column
                                    type="selection"
                                    width="55">
                            </el-table-column>
                            <el-table-column
                                    v-for="(header, index) in dataTable.Headers"
                                    :key="index"
                                    :prop="header.DataMember"
                                    :label="header.DisplayName"
                                    :title="header.Description"
                            >
                                <template slot-scope="scope">
                                    <div>
                                        <div v-if="header.DataType === 'DateTime'">
                                            <table-date :date="scope.row[header.DataMember]" />
                                        </div>
                                        <div v-else-if="header.DataType === 'Decimal'">
                                            {{scope.row[header.DataMember] | rubles }}
                                        </div>
                                        <div v-else-if="header.DataMember === 'Parameters'">
                                            <el-popover
                                                    placement="top-start"
                                                    title="Параметры"
                                                    trigger="hover">
                                                <span class="font-weight-bold" slot="reference">Показать</span>
                                                <params class="color-black" :data="scope.row[header.DataMember]"></params>
                                            </el-popover>
                                        </div>
                                        <div v-else>
                                            {{scope.row[header.DataMember]}}
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column fixed="right" label="Квитировать" width="160px">
                                <template slot-scope="scope">
                                    <el-button v-if="scope.row.ConfirmationRequired && scope.row.ConfirmationOperatorId === ''" @click="confirmEvent(scope.row.Id)">Квитировать</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-button class="m-t-20 m-l-20 m-b-20" :disabled="!multipleSelection.length" @click="confirmEvent()">Квитировать выделенные</el-button>
                    </div>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Params from '@/components/Params'
    import {mapMutations, mapGetters} from 'vuex'

    export default {
        components: { Params },
        data () {
            return {
                loading: false,
                loadingFilters: false,
                form: {
                    SearchString: '',
                    Type: '',
                    Level: '',
                    Confirm: '',
                    showNewEvents: true,
                    viewTable: false
                },
                dataTable: {
                    Headers: [],
                    LastEvents: []
                },
                dataTableTemp: {
                    Headers: [],
                    LastEvents: []
                },
                multipleSelection: [],
                audio: new Audio('/dist/media/notification.mp3'),
                types: [
                    {
                        id: 1,
                        value: 'Изменение параметра устройства'
                    },
                    {
                        id: 2,
                        value: 'Событие проезда'
                    }
                ],
                levels: [
                    {
                        id: 1,
                        value: 'Уровень: информация'
                    },
                    {
                        id: 2,
                        value: 'Уровень: предупреждение'
                    },
                    {
                        id: 3,
                        value: 'Уровень: ошибка'
                    }
                ],
                confirms: [
                    {
                        id: 1,
                        value: 'Квитированные'
                    },
                    {
                        id: 2,
                        value: 'Не квитированные'
                    },
                    {
                        id: 3,
                        value: 'Не требующие квитирования'
                    }
                ],
                timer: null,
                timetick: 0,
                filterActive: 0,
                filters: null,
                formDynamic: {}
            }
        },
        computed: {
            ...mapGetters(['initCondition']),
            dataTableFiltered () {
                let filtered = this.dataTable.LastEvents

                if (this.form.SearchString) {
                    filtered = filtered.filter(x => (x.DeviceId.search(this.form.SearchString) != -1 || x.Parameters.search(this.form.SearchString) != -1 || x.Type.search(this.form.SearchString) != -1 || x.Level.search(this.form.SearchString) != -1))
                }

                if (this.formDynamic.ColorScheme) {
                    filtered = filtered.filter(x => x.Level === this.formDynamic.ColorScheme)
                }
                if (this.formDynamic.Type) {
                    filtered = filtered.filter(x => x.Type === this.formDynamic.Type)
                }
                if (this.formDynamic.SpecificType) {
                    filtered = filtered.filter(x => {
                        if (x.SpecificType.toLowerCase().includes(this.formDynamic.SpecificType.toLowerCase())) {
                            return x
                        }
                    })
                }
                if (this.formDynamic.CardId) {
                    filtered = filtered.filter(x => x.CardId === this.formDynamic.CardId)
                }
                if (this.formDynamic.DeviceId) {
                    filtered = filtered.filter(x => x.DeviceId === this.formDynamic.DeviceId)
                }
                if (this.formDynamic.OperatorId) {
                    filtered = filtered.filter(x => x.OperatorId === this.formDynamic.OperatorId)
                }
                if (this.formDynamic.Parameters) {
                    filtered = filtered.filter(x => {
                        if (x.Parameters.toLowerCase().includes(this.formDynamic.Parameters.toLowerCase())) {
                            return x
                        }
                    })
                }
                if (this.formDynamic.ConfirmationRequired) {
                    filtered = filtered.filter(x => x.ConfirmationOperatorId === this.formDynamic.ConfirmationRequired)
                }

                return filtered
            }
        },
        beforeDestroy () {
            clearInterval(this.timer)
        },
        created () {
            this.form = this.initCondition({model: this.form})
            this.getFiltering()
            this.getData()

            this.timer = setInterval(() => {
                this.getData(1)
                if (this.timer < 1) {
                    clearInterval(this.timer)
                }
            }, 5000)
        },
        methods: {
            ...mapMutations(['setCondition']),
            columnVisibility (header, index) {
                if (this.detailedMode) {
                    if (index < 5) {
                        return true
                    } else {
                        return false
                    }
                }
                else {
                    return true
                }
            },
            tableRowClassName ({row}) {
                return row.ColorScheme
            },
            tableRowStyle ({row}) {
                if (row.BackgroundColor || row.ForegroundColor) {
                    return { backgroundColor: row.BackgroundColor, color: row.ForegroundColor }
                }
                else return ''
            },
            handleFilter () {
                this.getData()
            },
            handleChange () {
                this.getData()
            },
            showNewEvents () {
                this.dataTable = this.dataTableTemp
            },
            getFiltering () {
                this.loadingFilters = true
                let request = {
                    Name: 'GetReportFiltering',
                    ReportName: 'ArchiveEvents'
                }

                this.$api.Main.getReportFiltering(request).then(response => {
                    if (response.ErrorString) {
                        this.$message({
                            message: response.ErrorString,
                            type: 'error'
                        })
                    }
                    else {
                        this.filters = response.FilteringDescriptions
                    }
                    this.loadingFilters = false
                }).catch (() => {
                    this.loadingFilters = false
                })
            },
            getData (silent) {
                if (!silent) {
                    this.setCondition({ model: this.form })
                    this.loading = true
                }

                let request = Object.assign({
                    Name: 'GetLastEvents',
                    LastKnownEventTimeTick: this.timetick,
                    LastKnownEventsCount: 10
                }, this.form)

                if (this.filters) {
                    request.Filtration = this.filters[this.filterActive].Name
                }

                let self = this
                this.$api.Main.getLastEvents(request).then(response => {
                    this.loading = false

                    response.Headers = response.Headers.filter(x => x.ColumnVisible !== false)

                    if (this.timetick === 0) {
                        console.log('init')
                        if (this.form.showNewEvents) {
                            self.dataTable = response
                            self.dataTable.LastEvents = response.LastEvents
                        }
                        else {
                            if (!silent) {
                                self.dataTable = response
                            }
                            self.dataTableTemp = response
                        }
                    }
                    else {
                        response.LastEvents.map(row => {
                            console.log('update', row.Id)
                            let index = this.dataTable.LastEvents.findIndex(x => x.Id === row.Id)
                            if (this.form.showNewEvents) {
                                if (index !== -1) {
                                    //-- update properties in LastEvents array with vue reactivity
                                    Object.entries(row).map(prop => {
                                        Vue.set(this.dataTable.LastEvents[index], prop[0], prop[1])
                                    })
                                }
                                else {
                                    console.log('add new')
                                    this.dataTable.LastEvents.unshift(row)
                                }
                            }
                            else {
                                console.log('not show new')
                                if (!silent) {
                                    if (index !== -1) {
                                        this.dataTable.LastEvents[index] = row
                                        //-- update properties in LastEvents array with vue reactivity
                                        Object.entries(row).map(prop => {
                                            Vue.set(this.dataTable.LastEvents[index], prop[0], prop[1])
                                        })
                                    }
                                    else {
                                        this.dataTable.LastEvents.unshift(row)
                                    }
                                }
                                if (index !== -1) {
                                    this.dataTableTemp.LastEvents[index] = row
                                    //-- update properties in LastEvents array with vue reactivity
                                    Object.entries(row).map(prop => {
                                        Vue.set(this.dataTableTemp.LastEvents[index], prop[0], prop[1])
                                    })
                                }
                                else {
                                    this.dataTableTemp.LastEvents.unshift(row)
                                }
                            }
                        })
                    }

                    this.timetick = response.LastEvents[0].TimeTick
                    sessionStorage.setItem('events_timetick', this.timetick)

                    // this.audio.play()
                }).catch (() => {
                    this.loading = false
                })
            },
            changeNewEvents () {
                this.dataTableTemp.LastEvents = []
                this.getData()
            },
            changeView () {
                this.getData()
            },
            changeMode () {
                this.getData()
            },
            exportCSV () {
                console.log('export')
            },
            handleSelectionChange(val) {
                this.multipleSelection = val
            },
            confirmEvent (id) {
                this.$api.Main.confirmEvents({ Name: "ConfirmEvents", LongItemIds: (id ? [ id ] : this.multipleSelection.map((row) => { return row.Id })) }).then(response => {
                    this.$message({
                        message: (id ? 'Событие квитировано' : 'События квитированы'),
                        type: 'success',
                        res: response
                    })
                    this.getData()
                }).catch (() => {

                })
            },
            handleChangeFilter () {
                this.formDynamic = {}
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
    .events {
        .cards {
            display: grid;
            grid-template-columns: repeat( auto-fit, minmax(250px, 1fr) );
            grid-gap: 20px;
        }


        @media (min-width: 1366px) {
            .cards {
                grid-template-columns: repeat(auto-fit, minmax(350px, 1fr) );
            }
        }

        &__filters {
            display: grid;
            grid-template-columns: repeat( auto-fit, minmax(200px, 1fr) );
            grid-gap: 20px;

            align-items: center;
            justify-content: space-between;

            .right {
                justify-content: flex-end;
            }
        }

        .el-card__body {
            padding: 0;
        }
    }

    .detailed-name {
        background-color: #F5F6F9;
        padding: 10px 2px;
        color: #7F8188;
        border-bottom: 1px solid #ebeef5;
    }
    .detailed-value {
        padding: 10px 2px;
        border-bottom: 1px solid #ebeef5;
    }
</style>
